import dynamic from "next/dynamic";

export * from "@liveart/injectables/dist/navigationStack/navigationReducer";
export const ProgramNavigator = dynamic(() =>
    import("@liveart/injectables/dist/navigationStack/navigationStack").then(
        (module) => module.ProgramNavigator,
    ),
);
export * from "@liveart/injectables/dist/navigationStack/useNavigationStack";
